import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-up-right",
  templateUrl: "./med-icon-arrow-up-right.component.html",
})
export class MedIconArrowUpRightComponent extends SvgMixinComponent {}
